/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Timecodes_TitleInputs */



/**
* | output |
* | --- |
* | "Event Group Timecodes" |
*
* @param {Event_Group_Timecodes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_timecodes_title = /** @type {((inputs?: Event_Group_Timecodes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Timecodes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Codes temporels du groupe d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes der Ereignisgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codici temporali del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Временные метки групп событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Códigos de tiempo del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループのタイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Códigos de tempo do grupo de eventos")
	return /** @type {LocalizedString} */ ("Event Group Timecodes")
});